var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { DocumentRetrievalLocationStatus } from "healthex-common/document.retrieval.dtos";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class DocumentRetrievalLoginLocationViewModel {
    constructor(parentModel) {
        this.parentModel = parentModel;
    }
    get loginLocation() {
        const currentLoc = this.parentModel.currentLocationForLogin;
        if (!currentLoc)
            return null;
        const location = this.parentModel.locationList.find((loc) => loc.key === currentLoc.id);
        return location !== null && location !== void 0 ? location : null;
    }
    get locationName() {
        var _a, _b;
        return (_b = (_a = this.loginLocation) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
    }
    get locationLogoUrl() {
        var _a, _b;
        if (this.loginLocationIsMyChartCentral)
            return null;
        return (_b = (_a = this.loginLocation) === null || _a === void 0 ? void 0 : _a.logoUrl) !== null && _b !== void 0 ? _b : null;
    }
    get loginLocationIsMyChartCentral() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.loginLocation) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.myChartCentral) !== null && _c !== void 0 ? _c : false;
    }
    get myChartCentralLocationNames() {
        return this.parentModel.locationList.filter((loc) => { var _a, _b; return (_b = (_a = loc.metadata) === null || _a === void 0 ? void 0 : _a.myChartCentral) !== null && _b !== void 0 ? _b : false; }).map((loc) => loc.name);
    }
    get organizationName() {
        return this.parentModel.organizationName;
    }
    get title() {
        if (this.isWaitingForAuth)
            return t("Logging in...");
        if (this.isLoginSuccessful)
            return t("Log in successful");
        return t("Log in required");
    }
    get supportingText() {
        if (this.isWaitingForAuth)
            return this.parentModel.isIAS
                ? t("If you’re having trouble or can’t remember your credentials, continue without accessing these records.")
                : t("If you’re having trouble or can’t remember your credentials, continue without sharing these records.");
        if (this.isLoginSuccessful)
            return t("Continue to keep reviewing.");
        return this.parentModel.isIAS
            ? t("Otherwise, continue without accessing these records.")
            : this.parentModel.isAIFlow
                ? t("Otherwise, continue without connecting these records.")
                : t("Otherwise, continue without sharing these records.");
    }
    get loginButtonText() {
        if (this.hasLoginError)
            return t("Try again");
        if (this.isWaitingForAuth)
            return t("Logging in...");
        if (this.isLoginSuccessful)
            return t("Continue");
        return this.parentModel.isIAS
            ? t("Log in to access records")
            : this.parentModel.isAIFlow
                ? t("Log in to connect")
                : t("Log in to share records");
    }
    get skipButtonText() {
        return t("Skip records from this provider");
    }
    async handleLoginToShare() {
        if (this.loginLocation) {
            await this.parentModel.loginToLocation(this.loginLocation.key);
        }
    }
    get isWaitingForAuth() {
        var _a;
        return ((_a = this.loginLocation) === null || _a === void 0 ? void 0 : _a.key) === this.parentModel.authInProgress;
    }
    get isLoginSuccessful() {
        if (!this.loginLocation)
            return false;
        const locationKey = this.loginLocation.key;
        const locationInList = this.parentModel.locationList.find((loc) => loc.key === locationKey);
        if (!locationInList)
            return false;
        return locationInList.status === DocumentRetrievalLocationStatus.COMPLETE && !this.isWaitingForAuth && !this.hasLoginError;
    }
    get hasLoginError() {
        var _a;
        return !!this.parentModel.authErrorKey && ((_a = this.loginLocation) === null || _a === void 0 ? void 0 : _a.key) === this.parentModel.authErrorKey;
    }
    get loginErrorMessage() {
        if (!this.hasLoginError)
            return null;
        return this.parentModel.authErrorMessage;
    }
    async handleSkipLogin() {
        await this.parentModel.onLoginSkipped();
    }
    handleContinueAfterSuccess() {
        this.parentModel.onLoginSuccess();
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "loginLocation", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "locationName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "locationLogoUrl", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "loginLocationIsMyChartCentral", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "myChartCentralLocationNames", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "organizationName", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "title", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "supportingText", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "loginButtonText", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "skipButtonText", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "isWaitingForAuth", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "isLoginSuccessful", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "hasLoginError", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DocumentRetrievalLoginLocationViewModel.prototype, "loginErrorMessage", null);
